import { useQuery } from "@vue/apollo-composable";
import { ref, watch } from "vue";
import type { GetRestrictionsForOrganizationQuery } from "@/__generated__/types";

import GET_RESTRICTIONS_QUERY from "./useRestrictions.query";

export const restrictions =
	ref<GetRestrictionsForOrganizationQuery["restrictions"]>();

const useRestrictions = () => {
	const { result, loading, error } = useQuery(GET_RESTRICTIONS_QUERY);

	watch(result, () => {
		restrictions.value = result.value?.restrictions;
	});

	return {
		restrictions,
		loading,
		error,
	};
};

export default useRestrictions;
